import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  noPadding?: boolean;
}

export const Section: React.FC<SectionProps> = ({ children, className = '', id, noPadding = false }) => {
  return (
    <section id={id} className={`w-full max-w-5xl mx-auto px-6 md:px-12 ${noPadding ? '' : 'py-20 md:py-32'} ${className}`}>
      {children}
    </section>
  );
};